import { createActions } from 'redux-actions';

export default createActions(
  {
    SET_TEXT: (text) => ({ text }),
  },
  { prefix: 'CALLOUT' }
);
